<template>
    <div class="card-body">
        <div class="form">
            <div class="col-12">
                <label for="imagen">Imagen cabecera email:</label>
                <p>
                    <small>
                        MEDIDAS: 2182X287 - FORMATO: JPG  - PESO MÁXIMO: Menos de 25O KB
                        <br/>
                        * No introduzcas texto en la imagen. 
                    </small>                   
                </p>
                <template v-if="managerLocal.imagen_cabecera_productos_url">
                    <img :src="managerLocal.imagen_cabecera_productos_url" style="max-height: 300px"/>
                    <br/>
                    <Button class="mt-1" @click="imagenBorrada('imagen_cabecera_productos')">Borrar</Button>
                </template>
                <template v-else>
                    <Dropzone 
                        v-if="url"
                        :url="url"
                        :height="287"
                        :width="2182"
                        :acceptedFiles="'image/jpeg'"
                        @success="imagenSubida('imagen_cabecera_productos', ...arguments)"
                    />
                </template>
            </div>
            <hr/>
            <div class="col-12">
                <label for="imagen">Imagen publicidad email:</label>
                <p>
                    <small>
                        MEDIDAS: 2182X667 - FORMATO: JPG - PESO MÁXIMO: Menos de 25O KB
                        <br/>
                        * No introduzcas texto en la imagen. 
                    </small>                   
                </p>
                <template v-if="managerLocal.imagen_publicidad_productos_url">
                    <img :src="managerLocal.imagen_publicidad_productos_url" style="max-height: 300px"/>
                    <br/>
                    <Button class="mt-1" @click="imagenBorrada('imagen_publicidad_productos')">Borrar</Button>
                </template>
                <template v-else>
                    <Dropzone 
                        v-if="url"
                        :url="url"
                        :height="667"
                        :width="2182"
                        :acceptedFiles="'image/jpeg'"
                        @success="imagenSubida('imagen_publicidad_productos', ...arguments)"
                    />
                </template>
            </div>
            <hr/>
            <div class="col-12">
                <Button @click="guardarOpciones">Guardar</Button>
            </div>
        </div>
    </div>
</template>

<script>
    import Dropzone from '@/components/common/Dropzone';

    export default {
        props: ['manager'],
        data() {
            return {
                url: this.config.API_BASE + '/upload/image?permisos=public&api_key=' + localStorage.getItem('token'),
                managerLocal: this.manager
            }
        },
        methods: {
            guardarOpciones() {
                this.$emit('guardar', this.managerLocal);
            },
            imagenBorrada(campo) {
                switch (campo) {
                    case 'imagen_cabecera_productos':
                        this.managerLocal.imagen_cabecera_productos = null;
                        this.managerLocal.imagen_cabecera_productos_url = null;
                        break;
                    case 'imagen_publicidad_productos':
                        this.managerLocal.imagen_publicidad_productos = null;
                        this.managerLocal.imagen_publicidad_productos_url = null;
                        break;
                }
            },
            imagenSubida(campo, file, response) {
                switch (campo) {
                    case 'imagen_cabecera_productos':
                        this.managerLocal.imagen_cabecera_productos = response;
                        break;
                    case 'imagen_publicidad_productos':
                        this.managerLocal.imagen_publicidad_productos = response;
                        break;
                }
            }
        },
        components: {
            Dropzone
        }
    }
</script>
